import React, { useEffect, useState, useRef, RefObject } from 'react';
import Arrow from '../../../../../../../../images/svg/arrow';
import { IDropdownOption } from '../audio-bridge-configuration.viewmodel';
import './dial-in-select.scss';

export type DialInSelectProps = {
    selectedOption?: IDropdownOption;
    onChange(value: IDropdownOption): void;
    options: IDropdownOption[];
};

export const DialInSelect = (props: DialInSelectProps): JSX.Element => {
    const {
        onChange,
        options,
        selectedOption,
    } = props;

    const selectRef: RefObject<HTMLDivElement> | null = useRef<HTMLDivElement>(null);
    const [showDropDown, setShowDropDown] = useState<boolean>(false);

    const toggleDropDown = (): void => {
        setShowDropDown(!showDropDown);
    };

    const selectItem = (item: IDropdownOption): void => {
        onChange(item);
        setShowDropDown(false);
    };

    const handleOutsideClick = (e: Event): void => {
      const target = e.target as HTMLElement;
      if (selectRef?.current?.contains(target)) {
        return;
      }
      setShowDropDown(false);
    };


    useEffect(() => {
      document.addEventListener('mousedown', handleOutsideClick);
      return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
      };
    }, []);


    return (
        <div ref={selectRef} className='phone-select'>
            <div className='phone-select__selected-number-wrap' onClick={toggleDropDown}>
                <span>{selectedOption.value}</span>
                <Arrow />
            </div>
            <div className='phone-select__options'>
                <div className={`phone-select__options-wrapper phone-select__${showDropDown ? 'block' : 'hidden'}`}>
                    <div
                        onClick={toggleDropDown}
                        className={`phone-select__selected-first-child ${showDropDown && 'active'}`}
                    >
                        <span className='phone-select__option'>
                            {selectedOption.value}
                            <Arrow />
                        </span>
                    </div>

                    {options.map((option, index) => (
                        <div
                            key={index}
                            onClick={() => selectItem(option)}
                            className='phone-select__option'
                        >
                            <span>{option.value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
};

export default DialInSelect;
